import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import TextArea from '@/shared/Inputs/TextArea'
import { IAlarmSituation, TCreateAlarmSituationDTO } from '../../alarmSituations.types.ts'
import AlarmSituationsDataTypeDropdown from '../AlarmSituationsDataTypeDropdown'
import SeparateLine from '@/shared/Forms/SeparateLine'
import Toggle from '@/shared/Inputs/Toggle'
import EquipmentModelsMultiSelect from '@/pages/Equipment/pages/EquipmentModels/components/EquipmentModelsMultiSelect'
import AlarmSituationInputFormula from '../AlarmSituationInputFormula'

interface IProps {
  alarmSituation: IAlarmSituation | TCreateAlarmSituationDTO
  handleChange: (
    val: string | boolean | IAlarmSituation['equipmentModels'] | IAlarmSituation['formula'],
    name: string
  ) => void
}
const AlarmSituationFormFields = ({ alarmSituation, handleChange }: IProps) => {
  return (
    <div className="flex-lines gap16">
      <FormField label="Наименование" required>
        <TextInput name="name" onChange={handleChange} value={alarmSituation.name} placeHolder="Введите наименование" />
      </FormField>
      <FormField label="Тип" required>
        <AlarmSituationsDataTypeDropdown name="level" onChange={handleChange} value={alarmSituation.level} />
      </FormField>
      <FormField label="Комментарий" required>
        <TextArea
          name="comment"
          onChange={handleChange}
          value={alarmSituation.comment}
          placeHolder="Введите комментарий"
        />
      </FormField>
      <SeparateLine />
      <h5 className="text-heading-5">Пороговое значение</h5>
      <AlarmSituationInputFormula name="formula" value={alarmSituation.formula} onChange={handleChange} />
      <FormField label="">
        <div className="inline-flex-gap gap8 center">
          <Toggle
            name="forAllEquipment"
            onChange={handleChange}
            size="large"
            checked={alarmSituation.forAllEquipment}
          />
          <span>Вычислять для всех моделей</span>
        </div>
      </FormField>
      {!alarmSituation.forAllEquipment && (
        <FormField label="Не вычислять для">
          <EquipmentModelsMultiSelect
            name="equipmentModels"
            selected={alarmSituation.equipmentModels}
            onSelect={handleChange}
          />
        </FormField>
      )}
    </div>
  )
}

export default AlarmSituationFormFields
